import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class ReservationService {

  constructor(private http: HttpClient) { }

  savereservation(data: any): any {
    return this.http.post(`${API_URL}/reservation`, data, {
      observe: 'response',
    });
  }

  getAllReservtion(page= 0, size= 10): any {
    return this.http.get(`${API_URL}/reservation?page=${page}&size=${size}`);
  }
}
